export default __webpack_public_path__ + "static/media/marineDetailsIcon.b075e786.svg";